import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import Button from '../../../../components/Button';
import { ClaimProductTypeEnum } from '../../enums/ClaimProductType.enum';

type NewClaimDropdownProps = {
  onSelect: (productType: ClaimProductTypeEnum) => void;
};

const CLAIM_PRODUCT_OPTIONS: Array<{
  type: ClaimProductTypeEnum;
  label: string;
}> = [
  { type: ClaimProductTypeEnum.BOND, label: 'Seguro Fiança' },
  { type: ClaimProductTypeEnum.FIRE, label: 'Seguro Incêndio' },
  { type: ClaimProductTypeEnum.CONTENT, label: 'Conteúdo' },
  { type: ClaimProductTypeEnum.CONDOMINIUM, label: 'Condomínio' },
  { type: ClaimProductTypeEnum.LENDER, label: 'Prestamista' }
];

const DropdownMenu = styled(Dropdown.Menu)`
  z-index: 1000 !important;
  min-width: 220px !important;
`;

const NewClaimDropdown = ({ onSelect }: NewClaimDropdownProps) => {
  const trigger = (
    <Button icon type="button">
      <Icon name="hotjar" /> Novo Sinistro <Icon name="dropdown" />
    </Button>
  );

  return (
    <Dropdown trigger={trigger} icon={null}>
      <DropdownMenu>
        {CLAIM_PRODUCT_OPTIONS.map((option, index) => (
          <React.Fragment key={option.type}>
            {index === 1 && <Dropdown.Divider />}
            <Dropdown.Item
              text={option.label}
              onClick={() => onSelect(option.type)}
            />
          </React.Fragment>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default NewClaimDropdown;
